import {
  extractBirthDateFromPesel,
  extractGenderFromPesel,
} from "@/schemas/commonFields";
import { UseFormReturn } from "react-hook-form";
import { WriteContractor } from "@/types/contractor";

/**
 * Auto-fill birth date and gender from PESEL
 */
export const handlePeselChange = (
  pesel: string,
  form: UseFormReturn<WriteContractor>,
  onFieldsFilled?: () => void,
) => {
  if (pesel.length === 11) {
    const birthDate = extractBirthDateFromPesel(pesel);
    const gender = extractGenderFromPesel(pesel);

    let filledFields = false;

    if (birthDate) {
      form.setValue("birth_date", birthDate);
      filledFields = true;
    }

    if (gender) {
      form.setValue("gender", gender);
      filledFields = true;
    }

    if (filledFields && onFieldsFilled) {
      onFieldsFilled();
    }
  }
};
